import React from 'react'
import { ConfigProvider, Skeleton, Flex } from 'antd';


const AlertSkeleton: React.FC = () => {
    const [avatarWidth, setAvatarWidth] = React.useState(250);
    const [descriptionWidth, setDescriptionWidth] = React.useState(358);

    React.useEffect(() => {
        const updateWidths = () => {
            const screenWidth = window.innerWidth;
            if (screenWidth <= 350) {
                setAvatarWidth(120);
                setDescriptionWidth(150);
            } else if (screenWidth <= 370) {
                setAvatarWidth(140);
                setDescriptionWidth(180);
            } else if (screenWidth <= 390) {
                setAvatarWidth(160);
                setDescriptionWidth(220);
            } else if (screenWidth <= 410) {
                setAvatarWidth(180);
                setDescriptionWidth(260);
            } else if (screenWidth <= 430) {
                setAvatarWidth(210);
                setDescriptionWidth(300);
            } else {
                setAvatarWidth(250);
                setDescriptionWidth(358);
            }
        };

        updateWidths();
        window.addEventListener('resize', updateWidths);
        return () => window.removeEventListener('resize', updateWidths);
    }, []);

    return (
        <ConfigProvider
            theme={{
                components: {
                    Skeleton: {
                        gradientFromColor: "#404040",
                        gradientToColor: "#606060"
                    },
                },
            }}>




            <div className="bg-[#1E1E1E] flex flex-col h-[95px] justify-center align-center rounded-lg">
                <Flex justify="center" className='mt-2' vertical align="self-start">
                    <Flex className='px-1' gap={6} align='center' style={{ width: "100%" }}>
                        <Skeleton.Avatar active style={{ width: `20px`, height: "20px" }} shape="circle" />
                        <Skeleton.Input size='small' style={{
                            width: `${avatarWidth}px`, marginBottom: "12px", height: "13px"
                        }} active />
                    </Flex>
                    <div className='ml-[30px]'>
                        <Skeleton.Input size='small' style={{ width: `${descriptionWidth}px`, marginBottom: "12px", height: "10px" }} active />
                        <Skeleton.Input size='small' style={{ width: `143px`, height: "9px",  }} active />
                    </div>

                </Flex>
            </div>



        </ConfigProvider>
    )
}

export default AlertSkeleton


